//
//
//
//
//
//
//
//

export default {
  name: 'defaultEarth',
  data() {
    return {

    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {

  },
  mounted: function() {

  },
  methods: {

  }

}



// WEBPACK FOOTER //
// ./src/components/defaultEarth/index.vue